import enMessages from './en';
import heMessages from './he';

export const en = enMessages;
export const he = heMessages;
